import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { checkAndEvokeEmbedUrl } from 'utils/helpers/url';
import styles from './styles.module.scss';

const VideoPlayer = ({ player, _id, title, embedSrc, autoPlay }) => {
	const parsedPlayer = player ? parse(player) : {};
	const src = embedSrc || checkAndEvokeEmbedUrl({ player, _id }, autoPlay);

	return (
		<div className={styles.Player}>
			<iframe
				key={_id}
				title={title}
				{...parsedPlayer.props}
				width="100%"
				height="100%"
				border="0"
				src={src}
				allowFullScreen
				className={styles.Player__Iframe}
			/>
		</div>
	);
};

VideoPlayer.propTypes = {
	player: PropTypes.string,
	_id: PropTypes.number,
	title: PropTypes.string,
	onCloseButtonClick: PropTypes.func,
	markupAttributes: PropTypes.object,
	embedSrc: PropTypes.string,
	autoPlay: PropTypes.bool
};

VideoPlayer.defaultProps = {
	player: '',
	markupAttributes: {}
};

export default VideoPlayer;
